<template>
    <div>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        //
    },
    data: () => ({
        //
    }),
    methods: {
        //
    },
}
</script>
